import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import { Page, StyledButton, Fab } from "components/support";
import { colors } from "assets";

import Filter from "./filter";
import DataTable from "./data-table";

import "./customer.css";

class CustomerView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { filters, loading } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Clientes
            </Typography>
          </Col>

          <Col style={{ marginBottom: 20 }}>
            <StyledButton
              accent
              style={{ margin: 10 }}
              label="Configuração de Campos"
              onClick={() => presenter.onGoManageFields()}
            />
          </Col>

          <Col style={{ marginBottom: 20 }}>
            <StyledButton
              accent
              style={{ margin: 10 }}
              label="Download lista de Clientes"
              onClick={() => presenter.onDownload("csv")}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Filter
              filters={filters}
              loading={loading}
              onChange={(field, value) => presenter.onChange(field, value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <DataTable filters={filters} loading={loading} />
          </Col>
        </Row>

        <Fab
          backgroundColor={colors.button.secondary}
          onClick={() => presenter.onCreateCustomer()}
          icon="add"
        />
      </Page>
    );
  }
}

export default CustomerView;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view.jsx